import { css } from "../theme/styled-components";

export const defaultShadow = css`
  -webkit-box-shadow: 0px 2px 10px rgba(68, 68, 68, 0.25);
  -moz-box-shadow: 0px 2px 10px rgba(68, 68, 68, 0.25);
  box-shadow: 0px 2px 10px rgba(68, 68, 68, 0.25);
`;
